import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '@ibc-features/user/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-profile-selector',
  imports: [TranslateModule, RouterLink],
  templateUrl: './profile-selector.component.html',
  styleUrl: './profile-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileSelectorComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  protected readonly isLogged = this.authService.isLoggedIn;

  protected onLogout() {
    this.authService.logout().subscribe({
      next: () => {
        this.authService.currentUser.set(null);
        this.authService.isLoggedIn.set(false);
        this.router.navigate(['/']);
      },
      error: err => {
        console.error('Error during logout:', err);
      },
    });
  }
}
